import { Case, CaseListData } from "@repo/provider-network";
import type { Patient } from "../definitions";

/**
 * Filters visits for a specific patient using patient ID
 * Falls back to name-based matching if ID mapping is not available
 */
export const filterToPatientVisits = (
  visitData: CaseListData,
  selectedPatient: Pick<Patient, "id"> &
    Partial<Pick<Patient, "firstName" | "lastName">>
): Case[] => {
  // First try to find the MDI patient ID for this Kinsa patient
  const patientMapping = visitData.patients?.find(
    (p) => p.externalMemberId === selectedPatient.id
  );

  if (patientMapping?.providerNetworkMemberId) {
    // Use ID-based matching (preferred)
    const mdiPatientId = patientMapping.providerNetworkMemberId;
    return visitData.current.filter((visit: Case) => {
      return visit.patient?.patient_id === mdiPatientId;
    });
  }

  // Fallback to name-based matching if no ID mapping exists
  // This maintains backward compatibility for cases where the mapping isn't available yet
  const { firstName, lastName } = selectedPatient;

  if (!firstName || !lastName) {
    return [];
  }

  console.warn(
    `Using name-based matching for patient ${selectedPatient.id}. ID mapping not found.`
  );

  return visitData.current.filter((visit: Case) => {
    const patient = visit.patient;
    return patient?.first_name === firstName && patient?.last_name === lastName;
  });
};
